import { render, staticRenderFns } from "./ImpressaoRemDes.vue?vue&type=template&id=21b4a114&scoped=true&"
import script from "./ImpressaoRemDes.vue?vue&type=script&lang=js&"
export * from "./ImpressaoRemDes.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoRemDes.vue?vue&type=style&index=0&id=21b4a114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4a114",
  null
  
)

export default component.exports